import axios from "axios";
import { gettoken } from "../../../../shared/services/token/token";
import apiurl from "../apiendpoint/apiendpoint";

export const apisaveTestseries = async (datas) => {
    try {
        const formData = new FormData();
        
        const diagramFiles = [];
        const dataToSend = JSON.parse(JSON.stringify(datas));
        if (dataToSend.tests && Array.isArray(dataToSend.tests)) {
            dataToSend.tests.forEach((test, testIndex) => {
                if (test.questions) {
                    test.questions.forEach((question, qIndex) => {
                        const originalDiagram = datas.tests[testIndex].questions[qIndex].diagram;
                        if (originalDiagram instanceof File) {
                            diagramFiles.push({
                                file: originalDiagram,
                                testIndex,
                                qIndex
                            });
                            question.diagram = `DIAGRAM_${testIndex}_${qIndex}`;
                        }
                        
                        if (question.option_images && Array.isArray(question.option_images)) {
                            const originalOptionImages = datas.tests[testIndex].questions[qIndex].option_images;
                            
                            question.option_images = question.option_images.map((optionImage, optIndex) => {
                                const originalImage = originalOptionImages[optIndex];
                                
                                if (originalImage instanceof File) {
                                    diagramFiles.push({
                                        file: originalImage,
                                        testIndex,
                                        qIndex,
                                        optionIndex: optIndex,
                                        isOptionImage: true
                                    });
                                    return `OPTION_IMAGE_${testIndex}_${qIndex}_${optIndex}`;
                                }
                                
                                return optionImage;
                            });
                        }
                    });
                }
            });
        }
        
        diagramFiles.forEach(({ file, testIndex, qIndex, optionIndex, isOptionImage }) => {
            formData.append('diagrams', file);
            formData.append('diagramMapping', JSON.stringify({ 
                testIndex, 
                qIndex, 
                optionIndex: optionIndex !== undefined ? optionIndex : null,
                isOptionImage: isOptionImage || false
            }));
        });
        
        for (const key in dataToSend) {
            if (key === 'tests') {
                formData.append(key, JSON.stringify(dataToSend[key]));
            } else {
                formData.append(key, dataToSend[key]);
            }
        }
        
        const token = gettoken();
        const res = await axios.post(`${apiurl()}/test-series/apisaveTestseries`, formData, {headers: {"Authorization": `Bearer ${token}`,"Content-Type": "multipart/form-data"}});

        return res.data;
    } catch (err) {
        console.error('API Save Test series Error:', err.response ? err.response.data : err);
        throw err;
    }
};

export const apiupdateTestseries = async (datas) => {
    try {
        const formData = new FormData();
        const diagramFiles = [];
        const dataToSend = JSON.parse(JSON.stringify(datas));

        if (dataToSend.tests && Array.isArray(dataToSend.tests)) {
            dataToSend.tests.forEach((test, testIndex) => {
                if (test.questions) {
                    test.questions.forEach((question, qIndex) => {
                        const originalDiagram = datas.tests[testIndex].questions[qIndex].diagram;
                        if (originalDiagram instanceof File) {
                            const placeholder = `DIAGRAM_${testIndex}_${qIndex}`;
                            diagramFiles.push({
                                file: originalDiagram,
                                testIndex,
                                qIndex,
                                placeholder
                            });
                            question.diagram = placeholder;
                        }
                        
                        if (question.option_images && Array.isArray(question.option_images)) {
                            const originalOptionImages = datas.tests[testIndex].questions[qIndex].option_images;
                            
                            question.option_images = question.option_images.map((optionImage, optIndex) => {
                                const originalImage = originalOptionImages[optIndex];
                                
                                if (originalImage instanceof File) {
                                    const placeholder = `OPTION_IMAGE_${testIndex}_${qIndex}_${optIndex}`;
                                    diagramFiles.push({
                                        file: originalImage,
                                        testIndex,
                                        qIndex,
                                        optionIndex: optIndex,
                                        isOptionImage: true,
                                        placeholder
                                    });
                                    return placeholder;
                                }
                                
                                return optionImage;
                            });
                        }
                    });
                }
            });
        }

        diagramFiles.forEach(({ file, testIndex, qIndex, optionIndex, isOptionImage }) => {
            formData.append('diagrams', file);
            formData.append('diagramMapping', JSON.stringify({ 
                testIndex, 
                qIndex, 
                optionIndex: optionIndex !== undefined ? optionIndex : null,
                isOptionImage: isOptionImage || false
            }));
        });

        for (const key in dataToSend) {
            if (key === 'tests') {
                formData.append(key, JSON.stringify(dataToSend[key]));
            } else {
                formData.append(key, dataToSend[key]);
            }
        }

        if (!dataToSend._id) {
            throw new Error("Test series _id is required for update");
        }

        const token = gettoken();
        const res = await axios.put(`${apiurl()}/test-series/apiupdateadmintestseries`,formData,{headers: {"Authorization": `Bearer ${token}`,"Content-Type": "multipart/form-data"}});

        return res.data;
    } catch (err) {
        console.error('API Update Test series Error:', err.response?.data || err);
        throw err;
    }
};


export const getadminTestseries = async(params) => {
    const token = gettoken();
    const response = await axios.get(`${apiurl()}/test-series/apigetadmintestseries`,{params:params,headers:{"Authorization" :`Bearer ${token}`}});
    return response.data;
}

 export const apideleteTestSeries = async (id) => {
    try {
        const token = gettoken();
        const res = await axios.delete(`${apiurl()}/test-series/apideleteadmintestseries/${id}`,{headers: { "Authorization": `Bearer ${token}` }});
        return res.data;
    } catch (err) {
        console.log(err);
    }
};